export const dataPreloaderFr = {
    title_1: "CONTINUEZ UNIQUEMENT SI VOUS ÊTES MAJEUR",
    button: "ACCÉDER",
    title_2: "BIENVENUE À",
    logo: "/assets/images/el-secreto-logo.svg",
};
